module.exports = __webpack_public_path__ + "images/55d74a29bc3a34f84d548213718303da.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/blur_admin/src/assets/img/theme/palette.png
// module id = 1294
// module chunks = 2